/**
 * Runs the Latest Posts section located at the bottom of /dashboard
 *
 *
 */
e.D.latest_posts = {
	init : function(){
		var $latest_posts = $( '.latest-post-links' );
		$( '#filter-posts' ).find( 'select' ).on( 'change', this._filter_latest_posts );

		if( $latest_posts.length ){
			$latest_posts.find( '.delete-post' ).on( 'click', this._delete_post );
			$latest_posts.find( '.edit-post' ).on( 'click', e.D.note_assignment_forms.populate_edit_form );

			this._init_clipboard();
		}
	},

	_init_clipboard : function(){
		var clip = new Clipboard( '[data-js="edspire/latest-posts/link-to-post"]' );
		clip.on( 'success', function( el ){
			el.trigger.innerText =  'Copied';
			$(el.trigger).addClass( 'copied' );
		}.bind( this ) );
	},

	_filter_latest_posts : function(){
		var type = $(this ).val();
		var $latest_posts = $( '#latest-posts' );

		if( type == '' ){
			$latest_posts.find( '.latest-post' ).slideDown();
		} else {
			$latest_posts.find( '.latest-post.' + type ).slideDown();
			$latest_posts.find( '.latest-post' ).not( '.' + type ).slideUp();
		}

	},

	_delete_post : function(){
		var $post = $( this );
		if( confirm( config.i18n.delete_sure ) ){
			EdSpireAjax.Request( 'EdSpireMyClasses', 'deletePost', $post.data( 'post' ), function(){
				$post.parents( '.latest-post' ).slideUp( '1000', function(){
					$post.parents( '.latest-post' ).remove();
				} );
			} );
		}
	}
};